// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-calculator-view {
  width: 100%;
  position: relative;
}

.combined-results-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 1.25em;
  align-items: center;
  margin-bottom: 20px;
}
.download-button {
  padding: 10px 15px;
  background-color: #b51f25;
  font-family: "Fivo Sans Regular", sans-serif;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
}
.download-button:hover {
  background-color: #9e1c20;
}
.download-icon {
  margin-bottom: -0.125em;
}

.add-calculator-button {
  margin-right: 20px;
  padding: 10px 15px;
  background-color: #b51f25;
  font-family: "Fivo Sans Regular", sans-serif;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
}

.add-calculator-button:hover {
  background-color: #9e1c20;
}
.add-calculator-icon {
  margin-bottom: -0.125em;
}

.calculator-heading {
  text-align: center;
  margin-bottom: 20px;
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 1.5em;
  color: #d23038;
}

.calculators-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
  justify-content: center;
  padding-bottom: 5em;
}

.calculator {
  flex: 1 1;
  min-width: 260px;
  max-width: 280px;
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.calculator:hover {
  transform: scale(1);
}

.calculator table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Fivo Sans Regular", sans-serif;
  background-color: #fff;
  border-radius: 1.5em;
}

.calculator table thead {
  text-align: center;
  background-color: #f8f8f8;
  padding: 8px;
  font-size: 1em;
  font-family: "Fivo Sans Medium", sans-serif;
  color: #333;
}

.calculator th,
.calculator td {
  padding: 10px 8px;
  font-size: 0.75em;
  color: #333;
  text-align: left;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #ddd;
}

.calculator tr:last-child td {
  border-bottom: none;
}

.calculator select,
.calculator input {
  width: 100%;
  padding: 0.5em;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 12px;
  font-family: "Fivo Sans Regular", sans-serif;
  background: #f3f3f3;
}

.calculator input[type="number"] {
  appearance: textfield;
  width: auto;
}

.current-range {
  font-size: 0.8em;
  color: #d23038;
  white-space: nowrap;
  text-align: right;
}

.calculator input[type="number"]::-webkit-outer-spin-button,
.calculator input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ModuleCalculator/MultiCalculatorView.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EAGE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX","sourcesContent":[".multi-calculator-view {\n  width: 100%;\n  position: relative;\n}\n\n.combined-results-wrapper {\n  display: flex;\n  justify-content: space-between;\n  padding: 1.25em;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.download-button {\n  padding: 10px 15px;\n  background-color: #b51f25;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 1rem;\n  cursor: pointer;\n}\n.download-button:hover {\n  background-color: #9e1c20;\n}\n.download-icon {\n  margin-bottom: -0.125em;\n}\n\n.add-calculator-button {\n  margin-right: 20px;\n  padding: 10px 15px;\n  background-color: #b51f25;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.add-calculator-button:hover {\n  background-color: #9e1c20;\n}\n.add-calculator-icon {\n  margin-bottom: -0.125em;\n}\n\n.calculator-heading {\n  text-align: center;\n  margin-bottom: 20px;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 1.5em;\n  color: #d23038;\n}\n\n.calculators-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: flex-start;\n  justify-content: center;\n  padding-bottom: 5em;\n}\n\n.calculator {\n  flex: 1;\n  min-width: 260px;\n  max-width: 280px;\n  background-color: #f9f9f9;\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.calculator:hover {\n  transform: scale(1);\n}\n\n.calculator table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  background-color: #fff;\n  border-radius: 1.5em;\n}\n\n.calculator table thead {\n  text-align: center;\n  background-color: #f8f8f8;\n  padding: 8px;\n  font-size: 1em;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  color: #333;\n}\n\n.calculator th,\n.calculator td {\n  padding: 10px 8px;\n  font-size: 0.75em;\n  color: #333;\n  text-align: left;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 1px solid #ddd;\n}\n\n.calculator tr:last-child td {\n  border-bottom: none;\n}\n\n.calculator select,\n.calculator input {\n  width: 100%;\n  padding: 0.5em;\n  border-radius: 5px;\n  border: 1px solid #ddd;\n  font-size: 12px;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  background: #f3f3f3;\n}\n\n.calculator input[type=\"number\"] {\n  -webkit-appearance: none;\n  -moz-appearance: textfield;\n  appearance: textfield;\n  width: auto;\n}\n\n.current-range {\n  font-size: 0.8em;\n  color: #d23038;\n  white-space: nowrap;\n  text-align: right;\n}\n\n.calculator input[type=\"number\"]::-webkit-outer-spin-button,\n.calculator input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
